export default "__VITE_ASSET__Bm$Svqkh__"